import React, { useState, useEffect } from 'react';
import {
  getAdminRoleMaster
} from "../../../../apiservicescall/api";
import Table from '@mui/material/Table';
import { Link } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { Col, Badge, Card, Row, Button, Container } from "react-bootstrap";


const AdminManagment = () => {
  const [roleList, setRolelist] = useState([]);


  useEffect(() => {
    getadminroleMasterList();
  }, []);


  const getadminroleMasterList = async () => {
    let getroleList = await getAdminRoleMaster("1");
   // console.log("getroleList", getroleList?.data.data.userList);  
        setRolelist(getroleList?.data.data||[]);
    
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };
  const columns = [
   
    {
      name: "outletCode",
      label: "Outlet",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (outletCode, tableMeta, updateValue) => {
          return outletCode.map((role) => {
            return (
              <>
                {" "}
                <span className="badge badge-light" style={{color:"black",fontWeight:"bold"}}>
                  {role.outletName} - {role.outletCode}
                </span>
              </>
            );
          });
        },
      },
    },
    
    {
      name: "username",
      label: " Name",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "compName",
      label: "Company ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "userRole",
      label: "Role",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    
    {
      name: "mobileNo",
      label: "Mobile ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "emailId",
      label: "Email ID",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

  //   {
  //     name: "activeStatus",
  //     label: "activeStatus",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customFilterListOptions: { render: (v) => `UID: ${v}` },
  //       fixedHeader: true,
  //       responsive: "stacked",
  //       filterType: "textField",
  //     },
  //   },
  //   {
  //     name: "firstLoginStatus",
  //     label: "firstLoginStatus",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customFilterListOptions: { render: (v) => `UID: ${v}` },
  //       fixedHeader: true,
  //       responsive: "stacked",
  //       filterType: "textField",
  //     },
  //  },
   ]
   const options = {
    filter: true, 
    search: true, 
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "60vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
      
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} 
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
      // Handle filter confirmation here if needed
    },
    onFilterDialogOpen: () => {
      // Handle filter dialog open event if needed
    },
    onFilterDialogClose: () => {
      // Handle filter dialog close event if needed
    },
    customToolbar: () => {
      return (
        <>
           
              {/* //   {largeModal ? ( */}
              {/* //     <a */}
              {/* //       href="#"
              //       style={{ backgroundColor: "#008000", color: "white" }}
              //       onClick={(e) => opnAddNewUserModal(e)}
              //       className="caret btn-sm mr-10"
              //     >
              //       ADD <i className="zmdi zmdi-lus"></i>
              //     </a> */}
              {/* //   ) : (
              //     <a */}
              {/* //       href="#"
              //       style={{ */}
              {/* //         backgroundColor: "#008000",
              //         color: "white",
              //         fontSize: "medium",
              //       }}
              //       onClick={(e) => { */}
              {/* //         opnAddNewUserModal(e);
              //         setCustomerDetail({});
              //       }}
              //       className="caret btn-sm mr-10"
              //     >
              //       Add <i className="zmdi zmdi-lus"></i>
              //     </a> */}
              {/*  )} */}
            
        </>
      );
    },
  };
  <MUIDataTable
  title={""}
  data={roleList}
  columns={columns}
  options={options}
  className={"MuiTabCusCls"}
/>

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });
  return (
    <MuiThemeProvider theme={themeTable}>
    <MUIDataTable
       title={"Admin List"}
      data={roleList}
      columns={columns}
      // isView={isView}
       options={options}
      columOrder={columns}
      className={"MuiTabCusCls"}
    />
</MuiThemeProvider>
    );
}


export default AdminManagment